mutation DeleteReaction($input: ReactionDeleteInput!) {
    reactionDelete(input: $input) {
        reactionDeleted
    }
}
